import { render } from "./BaseSideNav.vue?vue&type=template&id=4061c7dc"
import script from "./BaseSideNav.vue?vue&type=script&lang=js"
export * from "./BaseSideNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__